import { render, staticRenderFns } from "./odoo-obligor-limit.vue?vue&type=template&id=f47ea55a&scoped=true&"
import script from "./odoo-obligor-limit.vue?vue&type=script&lang=js&"
export * from "./odoo-obligor-limit.vue?vue&type=script&lang=js&"
import style0 from "./odoo-obligor-limit.vue?vue&type=style&index=0&id=f47ea55a&lang=scss&scoped=true&"
import style1 from "./odoo-obligor-limit.vue?vue&type=style&index=1&id=f47ea55a&lang=scss&scoped=true&"
import style2 from "./odoo-obligor-limit.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47ea55a",
  null
  
)

export default component.exports